import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { FormFieldInput, FormFieldContainer, CharsCount } from "../../../react-components/modals/modal-form-elements";
import { SetProfileStatePayload, SetProfileStateAction, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { GRAPHQL_TYPE_ENTITY } from "@radivision/graphql";

interface MapStateProps {
  mission: string | null;
  isCompany: boolean;
}
interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

export type Props = MapStateProps & MapDispatchProps;

const MISSION_MAX_LENGTH = 300;

export const Component = (props: Props) => {
  const { setProfileState, mission, isCompany } = props;

  const [charsCount, setCharsCount] = React.useState<number>(0);
  const textareaId = "profile-company-mission-input";

  React.useEffect(() => {
    setCharsCount(mission ? mission.length : 0);
  }, [mission]);

  React.useEffect(
    function resizeTextarea() {
      const textarea = document.getElementById(textareaId);
      if (!textarea) {
        return;
      }
      try {
        textarea.setAttribute(
          "style",
          `min-height:100px;max-height:200px;height:${textarea.scrollHeight}px;overflow-y:auto;`,
        );
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
      } catch (error) {}
    },
    [textareaId],
  );

  if (!isCompany) return null;
  return (
    <FormFieldContainer>
      <label htmlFor={textareaId}>
        <span>Mission:</span>
      </label>
      <FormFieldInput>
        <textarea
          rows={3}
          name="mission"
          id={textareaId}
          maxLength={MISSION_MAX_LENGTH}
          placeholder={`What is your company's mission in ${MISSION_MAX_LENGTH} characters or less?`}
          value={mission}
          onChange={(e) => setProfileState({ mission: e.target.value })}
        />
        <CharsCount count={charsCount} limit={MISSION_MAX_LENGTH} />
      </FormFieldInput>
    </FormFieldContainer>
  );
};

const mapState = (state: AppState & ProfileModuleState) => ({
  mission: state.profile.mission,
  isCompany: state.profile.type === GRAPHQL_TYPE_ENTITY,
});

const mapDispatch = {
  setProfileState: setProfileState,
};

export const Mission = connect(mapState, mapDispatch)(Component);
